var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C21.5602 5.31725e-08 25.0404 1.05576 28.0006 3.03377C30.9607 5.01177 33.2678 7.82317 34.6301 11.1124C35.9924 14.4017 36.3487 18.021 35.6539 21.5128C34.9591 25.0045 33.2445 28.2118 30.7268 30.729C28.2092 33.2462 25.0016 34.9603 21.5097 35.6545C18.0178 36.3487 14.3986 35.9918 11.1095 34.6289C7.82052 33.2661 5.00952 30.9585 3.03203 27.998C1.05454 25.0375 -0.000615043 21.5571 2.68959e-07 17.9969C0.00123759 13.2237 1.89816 8.64633 5.27363 5.27143C8.64911 1.89654 13.2268 0.000412285 18 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5576 18.7933L15.8023 21.9042V15.6637L18.3984 17.0745L21.5576 18.7933ZM28.4453 14.5748C28.4453 14.5748 28.2399 13.0458 27.6022 12.3707C26.7887 11.4841 25.8912 11.4779 25.4665 11.4296C22.4831 11.2041 18.0002 11.2041 18.0002 11.2041H17.9909C17.9909 11.2041 13.5173 11.2041 10.5339 11.4296C10.1171 11.4779 9.21178 11.4841 8.39827 12.3707C7.76519 13.0458 7.54898 14.5748 7.54898 14.5748C7.41438 15.769 7.34221 16.9694 7.33276 18.1711V19.8635C7.34241 21.0657 7.41458 22.2666 7.54898 23.4613C7.54898 23.4613 7.75896 24.9903 8.39671 25.6669C9.21023 26.5536 10.2726 26.524 10.7486 26.6173C12.4596 26.7838 17.994 26.8367 17.994 26.8367C17.994 26.8367 22.4769 26.8367 25.4603 26.6065C25.8772 26.5536 26.7825 26.5536 27.596 25.6732C28.2337 24.9965 28.439 23.4675 28.439 23.4675C28.5748 22.2708 28.6485 21.0678 28.6599 19.8635V18.1758C28.6505 16.9725 28.5788 15.7706 28.4453 14.5748Z",
    fill: "#006DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f826b877bd69d3418b01e54957727e95.svg";
export { ForwardRef as ReactComponent };